'use strict';

import $ from 'jquery';
import { ZaimuDps } from './ZaimuDps';
import { ZaimuDpsTable } from './ZaimuDpsTable';
import { ZaimuDpsr } from './ZaimuDpsr';
import { ZaimuDpr } from './ZaimuDpr';

// 個別銘柄 - 配当・株主還元

$(function () {
    // 年間配当履歴グラフ生成
    ZaimuDps('#zaimu_dps');

    // 企業発表推移テーブル生成
    ZaimuDpsTable('#zaimu_dps_table');

    // 配当利回りグラフ生成
    ZaimuDpsr('#zaimu_dpsr');

    // 実績配当性向グラフ生成
    ZaimuDpr('#zaimu_dpr');
});
